<template>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
        <div class="selected" :class="{ open: open }" @click="open = !open">
            {{ selected }}
        </div>
        <div class="items" :class="{ selectHide: !open }">
            <div
                v-for="(option, i) of options"
                :key="i"
                @click="
                    selected = option;
                    open = false;
                    $emit('input', option);
                "
            >
                {{ option }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true
        },
        default: {
            type: String,
            required: false,
            default: null
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            selected: this.default
                ? this.default
                : this.options.length > 0
                ? this.options[0]
                : null,
            open: false
        };
    },
    mounted() {
        this.$emit('input', this.selected);
    }
};
</script>

<style scoped lang="scss">
@import '../assets/sass/_globals/colors';
@import '../assets/sass/_globals/mixins';

.custom-select {
    @include whitneyBook();
    position: absolute;
    width: 20rem;
    text-align: left;
    top: 2rem;
    left: 50%;
    transform: translateX(-50%);
    outline: none;
    height: 47px;
    line-height: 47px;
    z-index: 1002;
    text-transform: uppercase;

    @include until($tlp) {
        top: 8.5rem;
        z-index: 900;
    }

    .selected {
        background-color: $white;
        color: $blueDark;
        padding-left: 1em;
        cursor: pointer;
        user-select: none;

        &.open {
            border-bottom: 2px solid $blueDark;
        }

        &:after {
            position: absolute;
            content: '';
            background-image: url(../assets/imgs/icons/arrow-blue.svg);
            background-repeat: no-repeat;
            background-size: contain;
            width: 0.75em;
            height: 1em;
            position: absolute;
            top: 50%;
            right: 1.25em;
            transform: translateY(-50%) rotate(90deg);
        }
    }

    .items {
        color: #fff;
        overflow: hidden;
        position: absolute;
        background-color: $white;
        left: 0;
        right: 0;
        z-index: 1;

        div {
            color: $blueDark;
            padding-left: 1em;
            cursor: pointer;
            user-select: none;

            &:hover {
                background-color: $blueDark;
                color: $white;
            }
        }
    }
}

.selectHide {
    display: none;
}
</style>
